import { useMemo } from 'react';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { useIsWideStep } from '../hooks/useIsWideStep';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { Step } from '../views/Step';
import { getMessageComponent } from './getMessageComponent';
import { getMessageKey } from './getMessageKey';

const useMessageKey = () => {
  const {
    currentStep
  } = useCurrentStep();
  const {
    data: industry
  } = useSignupData(Data.Industry);
  const {
    isMobile
  } = useResponsiveness();
  return {
    messageKey: getMessageKey({
      currentStep,
      industry,
      isMobile
    })
  };
};

export const useMessage = () => {
  const {
    isWideStep
  } = useIsWideStep();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    shouldShowMessaging
  } = useSignupEmbedder();
  const {
    messageKey
  } = useMessageKey();
  const {
    currentStep
  } = useCurrentStep();
  const excludedSteps = [Step.CodeVerification, Step.ResendEmail, Step.Verification];
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const MessageComponent = useMemo(() => {
    if (messageKey) {
      return getMessageComponent({
        messageKey
      });
    }

    return null;
  }, // Do not re-render when just the industry is changing and not the step: that's when the user is typing.
  // We can change this once we make it a dropdown.
  [messageKey]);
  const noMessagingDisplayed = isInstanceOfSignupEmbedder && !shouldShowMessaging || isWideStep || isFramedCentredStep && !excludedSteps.includes(currentStep);
  const shouldDisplayMessaging = !noMessagingDisplayed;
  return {
    component: MessageComponent,
    shouldDisplayMessaging: shouldDisplayMessaging && MessageComponent
  };
};